import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
const baseApiTalkphr = environment.baseApiIpTalkPhr;
const baseApiDlicense = environment.baseAPIDrivingLicense;
@Injectable({
  providedIn: 'root'
})
export class VerifypatientService {
  progress$: any;
  private progressObserver: any;
  private progress: any;
  constructor(private GenericUtility: GenericUtilityService, private router: Router, private http: HttpClient) { }
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError('Something bad happened; please try again later.');
  }


  ManageActionItems(data: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckin", "ManageActionItems", data);
  }

  VerifyExistingPatientByDob(practice_code: any, first_name: any, last_name: any, dob: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/VerifyPatientByDOB_New?PracticeCode=" + practice_code + "&FirstName=" + first_name + "&LastName=" + last_name + "&DOB=" + dob);
  }

  VerifyExistingPatientByCellEmail(practice_code: any, cell: any, email: any, dob: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/VerifyPatientByEmailCell?PracticeCode=" + practice_code + "&Cell=" + cell + "&DOB=" + dob + "&Email=" + email);
  }

  VerifyPatient(data: any) {
    return this.GenericUtility.ApiPostMethod("checkinform", "GetPatientAgainst_Name_DOB", data);
  }
  cancelAppointment(data: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "CancelRestoreAppointments", data);
  }

  token: any = "";
  private apiUrl = baseApiTalkphr+'api/TalkCheckin/UpdateAppointmentStatus';
  ConfirmAppointment(appointmentId: any, status: any): Observable<any> {

      const url = `${this.apiUrl}?AppointmentId=${appointmentId}&Status=${status}`;
    this.token = localStorage.getItem("AuthTokenwebServices");
    if (!this.token || this.token == '' || this.token == undefined) {

      this.token = sessionStorage.getItem("AuthTokenwebServices");
      console.log("Getting token from ss GET " + this.token);
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Authorization': "Bearer " + this.token,
    });
    

    return this.http.post<any>(url, {}, { headers });
    
  }
  VerifyPatient_v1(data: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckInPhaseThree", "GetPatientAgainstNameDobApt", data);
  }
  getpatientInfocheckinflow(url: any, offset: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetGeneralPatientInformation?url=" + url + "&offset=" + offset);
  }

  getpatientAppointmentInfo(url: any, offset: any) {
    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckin/GetGeneralPatientAppointmentDetails?url=" + url + "&offset=" + offset);
  }

  Authentication(data: any) {
    return this.GenericUtility.ApiPostMethod("auth", "get_token", data);
  }
  private refreshTokenTimeout: any;

  lockScreenPage() {
    console.log("lock screen");
    sessionStorage.setItem("VisitedURL", window.location.pathname);
    this.stopRefreshTokenTimer();
    let loginURL = '/patient/verifypatient';
   // this.router.navigateByUrl(loginURL + "?lock-screen=");
    try {
      let accessLink = sessionStorage.getItem('AccessLink');
      //this.router.navigateByUrl(loginURL + "?pa=" + accessLink);
      if (accessLink) {
        window.location.href = `${loginURL}?pa=${accessLink}`;
      }
      //window.location.reload();

    } catch (error) {
      console.log("error inlock screen page line no 49 " + error);
      this.router.navigateByUrl(loginURL + "?lock-screen=");
    }
  }
  /*
  startPage() {
    console.log("start screen");
    this.stopRefreshTokenTimer();
    let loginURL = '/patient/verifypatient';
  
    try {
    
        window.location.href = `${loginURL}`;
      
      //window.location.reload();

    } catch (error) {
      console.log("error inlock screen page line no 49 " + error);
      this.router.navigateByUrl(loginURL + "?lock-screen=");
    }
  }*/

  startRefreshTokenTimer() {
    if (localStorage.getItem('AuthToken')) {
      const timeout = 10500000;
      this.refreshTokenTimeout = setInterval(() => { this.lockScreenPage() }, timeout);
    }
  }

  stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }

  SendOTP(obj: any) {
    return this.GenericUtility.ApiPostMethodOTP('MultiFactorAuth', 'SendOTP', obj);
  }
  VerifyOTP(obj: any) {
    return this.GenericUtility.ApiPostMethodOTP('MultiFactorAuth', 'VerifyOTP', obj);
  }
  OcrDrivingLicense(files: any) {
    return Observable.create((observer: any) => {

      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();

      // Set up CORS header (optional, if needed)
      // xhr.setRequestHeader('Access-Control-Allow-Origin', '*'); // Allows all origins, or specify a specific one

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        if (this.progressObserver)
          this.progressObserver.next(this.progress);
      };

      // Open the request to the specified URL
      xhr.open('POST', baseApiDlicense, true);

      // If files are provided, process and append them
      if (files == null) {
        //formData.append("pdf", "");  // If no file, send an empty field (optional)
      } else {
        if (files.type=="application/pdf") {
          formData.append('pdf', files);
        } else {
          formData.append('front_image', files);
          //formData.append('back_image', "");
        }
        
      }

      // Send the form data
      //console.log("Form data: ", formData);
      xhr.send(formData);
    });
  }


  uploadAtFolder(files: File, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any, ImageSubType: any) {

    return this.makeFileRequest(files, folder, PATIENT_ACCOUNT, PRACTICE_CODE, ImageSubType);
  }
  private makeFileRequest(files: File, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any, ImageSubType: any): Observable<any> {
    return Observable.create((observer: any) => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        if (this.progressObserver)
          this.progressObserver.next(this.progress);
      };
      xhr.open('POST', this.GenericUtility.getBaseIpTalkPhr() + folder, true);
      // for (let i = 0; i < files.length; i++) {
      formData.append("PatientAccount", PATIENT_ACCOUNT);
      formData.append("PracticeCode", PRACTICE_CODE);
      formData.append("image", files);
      formData.append("ImageSubType", ImageSubType);
      //formData.append("uploads", files[i].name);
      //formData.append("size", files[i], files[i].size.toString());
      //formData.append("type", files[i], files[i].type);
      // }
      //add JWT token for save profile pic
      xhr.setRequestHeader('Authorization', "Bearer " + localStorage.getItem("AuthTokenwebServices"));
      xhr.send(formData);
    });
  }

}
